import { Types, types } from '../types'





import {
  GetDashboardDataErrorPayload,
  GetDashboardDataSuccessPayload,
  GetFreeIVRErrorPayload,
  GetFreeSecretaryErrorPayload,
  GetServiceErrorPayload,
  GetServiceSuccessPayload,
  creditDetailsErrorPayLoad,
  creditDetailsRequestPayload,
  creditDetailsSuccessPayload,
  getFreeIVRSuccessPayload,
  getFreeSecretarySuccessPayload,
} from '../interfaces/serviceDashboard'
import {
  creditDetailsError,
  creditDetailsRequest,
  creditDetailsSuccess,
  getDashboardDataError,
  getDashboardDataRequest,
  getDashboardDataSuccess,
  getFaxError,
  getFaxRequest,
  getFaxSuccess,
  getFreeIVRError,
  getFreeIVRRequest,
  getFreeIVRSuccess,
  getFreeScretaryRequest,
  getFreeSecretaryError,
  getFreeSecretarySuccess,
  getIvrError,
  getIvrRequest,
  getIvrSuccess,
  getSecretaryError,
  getSecretaryRequest,
  getSecretarySuccess,
  resetFreeService
} from '../types/serviceDashboard/actionTypes'


export const creditDetailsRequestAction = (payload:creditDetailsRequestPayload): creditDetailsRequest => ({
  type: Types.GET_CREDIT_DETAILS_REQUEST,
  payload
})
export const creditDetailsSuccessAction = (payload: creditDetailsSuccessPayload): creditDetailsSuccess => ({
  type: Types.GET_CREDIT_DETAILS_SUCCESS,
  payload
})
export const creditDetailsErrorAction = (payload: creditDetailsErrorPayLoad): creditDetailsError => ({
  type: Types.GET_CREDIT_DETAILS_ERROR,
  payload
})

export const getSecretaryInfoRequestAction = (): getSecretaryRequest => ({
  type: Types.GET_SECRETARY_INFO_SERVICE_REQUEST,
})
export const getSecretaryInfoSuccessAction = (payload: GetServiceSuccessPayload): getSecretarySuccess => ({
  type: Types.GET_SECRETARY_INFO_SERVICE_SUCCESS,
  payload
})
export const getSecretaryInfoErrorAction = (payload: GetServiceErrorPayload): getSecretaryError => ({
  type: Types.GET_SECRETARY_INFO_SERVICE_ERROR,
  payload
})

//IVR***************************************************************************************************************
export const getIvrInfoRequestAction = (): getIvrRequest => ({
  type: Types.GET_IVR_INFO_SERVICE_REQUEST,
})
export const getIvrInfoSuccessAction = (payload: GetServiceSuccessPayload): getIvrSuccess => ({
  type: Types.GET_IVR_INFO_SERVICE_SUCCESS,
  payload
})

export const getIvrInfoErrorAction = (payload: GetServiceErrorPayload): getIvrError => ({
  type: Types.GET_IVR_INFO_SERVICE_ERROR,
  payload
})

export const resetPropsIvrInfoAction = () => ({
  type: Types.IVR_INFO_SERVICE_RESET_PROPS,
})

//FAX*******************************************************************************************************************
export const getFaxInfoRequestAction = (): getFaxRequest => ({
  type: Types.GET_FAX_INFO_SERVICE_REQUEST,
})
export const getFaxInfoSuccessAction = (payload: GetServiceSuccessPayload): getFaxSuccess => ({
  type: Types.GET_FAX_INFO_SERVICE_SUCCESS,
  payload
})

export const getFaxInfoErrorAction = (payload: GetServiceErrorPayload): getFaxError => ({
  type: Types.GET_FAX_INFO_SERVICE_ERROR,
  payload
})

export const resetPropsFaxInfoAction = () => ({
  type: Types.GET_FAX_INFO_RESET_PROPS,
})

//Dashboard**************************************************************************************************************
export const getDashboardDataRequestAction = (): getDashboardDataRequest => {
  return {
    type: Types.GET_DASHBOARD_DATA_REQUEST,
  }
}

export const getDashboardDataSuccessAction = (payload: GetDashboardDataSuccessPayload): getDashboardDataSuccess => {
  return {
    type: Types.GET_DASHBOARD_DATA_SUCCESS,
    payload
  }
}

export const getDashboardDataErrorAction = (payload: GetDashboardDataErrorPayload): getDashboardDataError => {
  return {
    type: Types.GET_DASHBOARD_DATA_ERROR,
    payload
  }
}
export const resetDashboardData = () => {
  return {
    type: Types.GET_DASHBOARD_DATA_RESET_PROPS
  }
}
//getLatestCustomerCalls************************************************************************************************************************** */

// export const getLatestCustomerCallsRequestAction = (): getLatestCustomerCallsRequest => {
//   return {
//     type: Types.GET_LATEST_CUSTOMER_REQUEST,
//   }
// }

// export const getLatestCustomerCallsSuccessAction = (payload: getLatestCustomerSuccessPayload): getLatestCustomerCallsSuccess => {
//   return {
//     type: Types.GET_LATEST_CUSTOMER_SUCCESS,
//     payload
//   }
// }

// export const getLatestCustomerCallsErrorAction = (payload: getLatestCustomerErrorPayload): getLatestCustomerCallsError => {
//   return {
//     type: Types.GET_LATEST_CUSTOMER_ERROR,
//     payload
//   }
// }
//FreeIVR********************************************************************************************************************* */
export const getFreeSecretaryRequestAction = (): getFreeScretaryRequest => ({
  type: Types.GET_FREE_SECRETARY_PACKAGE_REQUEST,
})
export const getFreeSecretarySuccessAction = (payload: getFreeSecretarySuccessPayload): getFreeSecretarySuccess => ({
  type: Types.GET_FREE_SECRETARY_PACKAGE_SUCCESS,
  payload
})

export const getFreeSecretaryErrorAction = (payload: GetFreeSecretaryErrorPayload): getFreeSecretaryError => ({
  type: Types.GET_FREE_SECRETARY_PACKAGE_ERROR,
  payload
})

//FreeIVR********************************************************************************************************************
export const getFreeIVRRequestAction = (): getFreeIVRRequest => ({
  type: Types.GET_FREE_IVR_PACKAGE_REQUEST,
})
export const getFreeIVRSuccessAction = (payload: getFreeIVRSuccessPayload): getFreeIVRSuccess => ({
  type: Types.GET_FREE_IVR_PACKAGE_SUCCESS,
  payload
})

export const getFreeIVRErrorAction = (payload: GetFreeIVRErrorPayload): getFreeIVRError => ({
  type: Types.GET_FREE_IVR_PACKAGE_ERROR,
  payload
})

export const resetFreeServiceAction=():resetFreeService=>({
  type: Types.RESET_FREE_SERVICE,
})











